class ShopGroupController extends AbstractEntityEditController
	@register()
	@inject 'translate',
		'shopGroup'
		'treeItems'
		'shopsList'
		'productsList'
		'ShopGroupRepository'
		'ShopRepository'
		'ProductRepository'
		'types': 'BACKEND_SHOP_GROUP_ENTITY_TYPE'

	initialize: ->
		@mainCrud.entityType = 'general.shop.group'
		@mainCrud.entityTitle = 'general.shop.group'

		{count: @productsCount, data: @products} = @productsList
		{count: @shopsCount, data: @shops} = @shopsList

		if @shopGroup.id?
			@mainCrud.entityTitle = @shopGroup.name
			@mainCrud.isNewEntity = false
			@invalidParents = @getInvalidParents(@shopGroup.id)
		else
			@shopGroup.entity_type = @types.PRODUCT_SHOP_GROUP
			@mainCrud.isNewEntity = true

		@productsPager = new TableService(@productsCount, => @search(true))
		@shopsPager = new TableService(@shopsCount, => @search(false))

		# Populate parent input select with existing shop groups
		@shopGroups = _.reject @treeItems, {id: @shopGroup.id}

		@tabs = [
			{
				selector: '#tab-details'
				title: 'wbo.tab.details'
				active: true
			},
			{
				selector: '#tab-products'
				title: 'wbo.shop.groups.tab.products'
				subtitle: "(#{@productsCount})"
				type: 'products'
				disabled: @mainCrud.isNewEntity
				inactive: @productsCount == 0
			},
			{
				selector: '#tab-shops'
				title: 'wbo.shop.groups.tab.shops'
				subtitle: "(#{@shopsCount})"
				type: 'shops'
				disabled: @mainCrud.isNewEntity
				inactive: @shopsCount == 0
			}
		]

	save: ->
		# Do not show error if previous set
		@childShopGroupExist = false

		@ShopGroupRepository
			.save @shopGroup, @mainCrud.isNewEntity
			.then (response) =>
				@afterSave(response)
			.catch (response) =>
				@handleErrors response.data

	delete: ->
		@childShopGroupExist = false

		if @getInvalidParents(@shopGroup.id).length > 1
			@childShopGroupExist = true

		if !@childShopGroupExist
			@deleteEntity @ShopGroupRepository, @shopGroup
				.then =>
					@treeItems = _.reject @treeItems, {id: @shopGroup.id}

	getInvalidParents: (shopGroupIds) ->
		shopGroupIds = [shopGroupIds] if typeof shopGroupIds is 'string'
		invalid = shopGroupIds

		## Add children
		for shopGroupId in shopGroupIds
			children = _.where(@shopGroups, {parent_id: shopGroupId})

			if children
				childIds = @getInvalidParents(_.pluck(children, "id"))
				invalid = invalid.concat(childIds)

		return invalid

	isValidParentId: (parentId) ->
		if !parentId
			return true

		return !_.contains(@invalidParents, parentId)

	search: (isForProducts) ->
		if isForProducts == 'products'
			repository = @ProductRepository
			pager = @productsPager
		else
			repository = @ShopRepository
			pager = @shopsPager

		query = repository.getQuery()
		query.with 'shop_groups'
		query.criteria 'shop_groups.id', '=', @shopGroup.id

		query.setPagination pager.page * pager.pageSize - pager.pageSize, pager.pageSize

		repository
			.getEntities query
			.then (response) =>
				if isForProducts == 'products'
					@products = response
				else
					@shops = response
